export default __webpack_public_path__ + "static/media/avatar_man.28cd256a.jpg";